import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuilderPageComponent } from './pages/builder-page/builder-page.component';
import { DemoComponent } from './pages/demo/demo.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { blogPageResolver } from './pages/blog-page/blog-page.resolver';
import { BlogPromoPreviewComponent } from './pages/blog-promo-preview/blog-promo-preview.component';
import { audienceGuard, homepageRedirectGuard } from './guards/audience.guard';

/**
 * Route Configuration for Multi-Domain Audience-Based Routing
 * 
 * URL Structure (all under /content-hub):
 * - /content-hub/:audience → Homepage (highschool or highered)
 * - /content-hub/:audience/ref/** → Blog articles (ref type)
 * - /content-hub/:audience/post/** → Blog articles (post type)
 * - /content-hub/:audience/** → Other Builder.io pages
 * 
 * Domain Mapping:
 * - *.bfwpub.* → highschool
 * - *.macmillan*.* → highered
 */
const routes: Routes = [
  // Utility routes (domain-agnostic)
  { path: 'demo', component: DemoComponent },
  { path: 'blog-promo', component: BlogPromoPreviewComponent },
  { path: 'blog-promo/:entryName', component: BlogPromoPreviewComponent },

  // Builder.io preview route for blog articles (for visual editor)
  // This allows Builder.io to preview blogs at /blog/:slug
  {
    path: 'blog',
    children: [
      {
        path: '**',
        component: BlogPageComponent,
        resolve: { blogArticle: blogPageResolver },
        data: { slugPrefix: '' } // No prefix for preview mode
      }
    ]
  },

  // Blog routes - /:audience/ref/** and /:audience/post/**
  // The slugPrefix is passed to the resolver to construct the full slug
  { 
    path: ':audience/ref',
    canActivate: [audienceGuard],
    data: { slugPrefix: '/ref' },
    children: [
      {
        path: '**',
        component: BlogPageComponent,
        resolve: { blogArticle: blogPageResolver }
      }
    ]
  },
  { 
    path: ':audience/post',
    canActivate: [audienceGuard],
    data: { slugPrefix: '/post' },
    children: [
      {
        path: '**',
        component: BlogPageComponent,
        resolve: { blogArticle: blogPageResolver }
      }
    ]
  },

  // Audience homepage and subpages - /:audience/**
  { 
    path: ':audience',
    canActivate: [audienceGuard],
    children: [
      {
        path: '**',
        component: BuilderPageComponent
      }
    ]
  },

  // Root without audience - redirect to audience homepage
  {
    path: '',
    pathMatch: 'full',
    canActivate: [homepageRedirectGuard],
    component: BuilderPageComponent
  },

  // Catch-all fallback (should rarely be hit due to redirects)
  { path: '**', component: BuilderPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
